<template>
    <div class="search">
        <div class="search__input input-field input-field--black">
            <label for="search-query" class="sr-only">Sök</label>

            <input type="text" v-model="filterStore.searchQuery" id="search-query"
                :placeholder="SEARCH_PLACEHOLDER"
                v-on:keyup.enter="addSearchQuery(filterStore.searchQuery)"/>
            <span class="search__icon icon icon--search" aria-hidden="true"></span>
        </div>
        <div v-if="filterStore.activeSearchFilters.length > 0" class="search__filters">
            <div class="filter" v-for="(filter, index) in filterStore.activeSearchFilters" :key="index" @click="removeSearchFilter(filter)">
                {{ filter }} <Cross />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">

import { useFilterState } from "@/services/filter-state-service";
import { useFilterStore } from "../../stores/filterStore";
import Cross from '../cross/Cross.vue';
import { SEARCH_PLACEHOLDER } from '@/constants';
const filterStore = useFilterStore();

const { addSearchFilter, removeSearchFilter } = useFilterState();

const addSearchQuery = (query: string) => {
    if (query === '') {
        return;
    }

    addSearchFilter(query);
    clearSearch();
};

const clearSearch = () => {
    filterStore.searchQuery = '';
};

</script>
